import { Bill } from '@melio/platform-api';

export const isPartiallyPaidBill = (bill: Bill) => 0 < bill.balance && bill.balance < bill.amount;
